<template>
<form
  method="post"
  action="/user/check"
  ref="form"
  novalidate="true"
  @submit.prevent="handleSubmit">
  <input type="hidden" name="cpno" :value="cpno">
  <input type="hidden" name="_token" :value="token">

  <div class="contentBody">
    <div class="contentBody__title">
      <span class="text">新規会員登録</span>
    </div>
    <div class="contentBody__section">
      <form-input
        name="nickname"
        v-model="nickname"
        type="text"
        placeholder="全角・半角英数字で入力してください"
        label="ニックネーム"
        :validation="{ rules: {
          required: true,
          max: 15
        } }"
      ></form-input>

      <form-input
        name="email"
        type="email"
        v-model="email"
        placeholder="半角英数字で入力してください"
        label="メールアドレス"
        :validation="{ rules: {
          required: true,
          email: false,
          nonRfcEmailCheck: true,
          duplicateEmail: true,
          max: 100
        } }"
      ></form-input>

      <form-password
        name="password"
        :show-strength="true"
        placeholder="半角英数字で入力してください"
        label="パスワード"
        v-model="password"
        :validation="{ rules: {
          required: true,
          max: 30,
          min: 8,
          passCheck2: true,
          passCheck1: true
        } }">
        <p class="formGroup__subText">半角の英数大文字、英数小文字、数字を組み合わせて8文字以上30文字以内にしてください。</p>
      </form-password>

      <div class="u-mg-t-6 u-mg-b-4">
        <label class="confirmTerms  u-mb-t-2">
          <input type="checkbox"
          class="confirmTerms__checkbox"
          name="terms"
          value="1"
          required
          v-validate="'required'"
          >
          <span class="confirmTerms__label"><a href="https://agaru.tv/terms-of-service/" target="_new">利用規約</a>と<a href="https://agaru.tv/privacy/" target="_new">プライバシーポリシー</a>に同意する</span>
        </label>
        <p v-show="errors.has('terms')" class="formGroup__errorMessage">利用規約へ同意して頂く必要があります。</p>
      </div>

    </div>
  </div>
  <div class="contentFooter">
    <button type="submit" class="btn"
      data-color="brand"
      data-block="true"
    >入力した内容を確認</button>
  </div>
</form>
</template>

<script>
import { mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'register-form',
  inject: ['$validator'],
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken,
      nickname: '',
      email: '',
      password: ''
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          return false
        } else {
          this.$refs.form.submit()
        }
      })
    }
  }
}</script>

<style lang="scss">
.authForm {
  &__body {
    padding: 16px 16px 64px;
    background: #FFF;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/RegisterForm.vue